import { Box } from '@mantine/core';
import { useGetColor } from '../hooks';
import type { IconPropsType } from './types';

export type DocumentSignatureIconProps = IconPropsType & {
  multipage?: boolean;
  signature?: 'left' | 'right';
};

export const DocumentSignatureIcon: React.FC<DocumentSignatureIconProps> = ({
  multipage = false,
  signature = 'left',
  color,
  size = 24,
  sx,
  ...props
}) => {
  const iconColor = useGetColor(color);

  return (
    <Box
      component="svg"
      sx={sx}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {multipage && signature === 'right' && (
        <>
          <rect x="0.75" y="0.75" width="14.5" height="19.5" fill="white" />
          <rect
            x="0.75"
            y="0.75"
            width="14.5"
            height="19.5"
            stroke={iconColor}
            strokeWidth="1.5"
          />
          <rect x="3" y="15" width="7" height="2" fill={iconColor} />
          <rect x="3.75" y="3.75" width="14.5" height="19.5" fill="white" />
          <rect
            x="3.75"
            y="3.75"
            width="14.5"
            height="19.5"
            stroke={iconColor}
            strokeWidth="1.5"
          />
          <rect x="9" y="18" width="7" height="2" fill={iconColor} />
        </>
      )}

      {multipage && signature === 'left' && (
        <>
          <rect x="0.75" y="0.75" width="14.5" height="19.5" fill="white" />
          <rect
            x="0.75"
            y="0.75"
            width="14.5"
            height="19.5"
            stroke={iconColor}
            strokeWidth="1.5"
          />
          <rect x="3" y="15" width="7" height="2" fill={iconColor} />
          <rect x="3.75" y="3.75" width="14.5" height="19.5" fill="white" />
          <rect
            x="3.75"
            y="3.75"
            width="14.5"
            height="19.5"
            stroke={iconColor}
            strokeWidth="1.5"
          />
          <rect x="6" y="18" width="7" height="2" fill={iconColor} />
        </>
      )}

      {signature === 'right' && (
        <>
          <rect x="0.75" y="0.75" width="15.5" height="21.5" fill="white" />
          <rect
            x="0.75"
            y="0.75"
            width="15.5"
            height="21.5"
            stroke={iconColor}
            strokeWidth="1.5"
          />
          <rect x="7" y="17" width="7" height="2" fill={iconColor} />
        </>
      )}

      {signature === 'left' && (
        <>
          <rect x="0.75" y="0.75" width="15.5" height="21.5" fill="white" />
          <rect
            x="0.75"
            y="0.75"
            width="15.5"
            height="21.5"
            stroke={iconColor}
            strokeWidth="1.5"
          />
          <rect x="3" y="17" width="7" height="2" fill={iconColor} />
        </>
      )}
    </Box>
  );
};
